import { gql } from 'apollo-boost'

const HTML_MENU_SCRAPING_SESSIONS = gql`
  query htmlMenuScrapingSessionsForCluster(
    $menuScrapingClusterId: ID!
    $page: Int
    $pageSize: Int
  ) {
    htmlMenuScrapingSessionsForCluster(
      menuScrapingClusterId: $menuScrapingClusterId
      page: $page
      pageSize: $pageSize
    ) {
      htmlMenuScrapingSessions {
        id
        status
        createdDate
        createdBy {
          id
          name
        }
        timeSlotCount
        startTime
        estimatedCompletionTime
        completedDate
        totalMenuCount
        scrapedMenuCount
        scrapingInstructionsVersionNumber
        configuration
        jobCountByScrapingStatus
      }
      total
    }
  }
`

export default HTML_MENU_SCRAPING_SESSIONS
